module.exports = __webpack_public_path__ + "img/opinion-survey.39a24828.svg";